<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 ">
                <card class="card-user">
                    <p class="card-text"></p>
                    <div class="author">
                        <div class="block block-one"></div>
                        <div class="block block-two"></div>
                        <div class="block block-three"></div>
                        <div class="block block-four"></div>
                        <a href="javascript:void(0)">
                            <img v-if="school.is_chinuchuk" class="avatar" style="border: 0;"
                                 src="img/ChinuchUKlogo721.png" alt="Chinuch UK logo"/>
                            <img v-if="!school.is_chinuchuk" class="avatar" style="border: 0;"
                                 src="img/Hoptone_Logo_Horizontal.png" alt="..."/>
                            <h5 class="title">{{ school.name }}</h5>
                        </a>
                        <p class="description">School</p>
                    </div>
                    <p></p>
                    <div class="card-description">
                        Your principal PIN: {{ school.principal_pin}}
                    </div>
                    <div class="card-footer text-center">
                        <a :href="'https://admin.hoptone.com/school/' + school.id">
                            <base-button type="info">
                                View Instructions PDF
                            </base-button>
                        </a>
                    </div>
                </card>

                <hotline-card title="General School Message"
                              :resource-url="baseAPIURL + 'school/' + school.id + '/message/'"></hotline-card>
            </div>
            <div class="col-md-8">
                <classroom-table v-if="classrooms" :classrooms="classrooms"/>
            </div>
            <div class="col-md-12">
                <school-call-statistics v-if="school.id" :school_id="school.id"></school-call-statistics>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from "axios";
    import SchoolCallStatistics from "./SchoolCallStatistics";
    import ClassroomTable from "./ClassroomTable";
    import HotlineCard from "./HotlineCard";

    export default {
        components: {
            HotlineCard,
            ClassroomTable,
            SchoolCallStatistics,

        },
        data() {
            return {
                classrooms: [],
                school: {},
                loading: {
                    school: false,
                    classrooms: false,
                },
                uploading: false,
                uploadingTemporaryMessage: false,
                loadingMessages: true,
                loadingTemporaryMessage: true,
                messages: [],
                removing: [],
                temporaryMessage: false,
                recording: null,
            };
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },

        },
        methods: {
            updateShow(value) {
                this.showCreateModal = value;
            },
            loadSchool() {
                this.loading.school = true;
                return axios({
                    url: this.baseAPIURL + 'school', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.school = resp.data.data;
                }).finally(() => {
                    this.loading.school = false;
                });
            },
            loadClassrooms() {
                this.loading.classrooms = true;
                axios({
                    url: this.baseAPIURL + 'school/' + this.school.id + '/classroom', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.classrooms = resp.data.data;
                }).finally(() => {
                    this.loading.classrooms = false;
                });
            },

        },
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }


            this.loadSchool().then(() => {
                this.loadClassrooms();
            })
        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    };
</script>
